<script setup lang="ts">
import Skeleton from 'primevue/skeleton';
</script>

<template>
  <div class="flex flex-col gap-6">
    <!-- Action buttons skeleton -->
    <div class="items-top flex justify-end gap-6">
      <Skeleton class="!h-8 !w-8 !rounded-full bg-primary-300 dark:bg-primary-500" />
      <Skeleton class="!h-8 !w-8 !rounded-full bg-primary-300 dark:bg-primary-500" />
    </div>

    <!-- Main dish image skeleton -->
    <div class="my-5 flex justify-center">
      <Skeleton class="!h-60 !w-60 !rounded-lg bg-primary-300 dark:bg-primary-500" />
    </div>

    <!-- Date skeleton -->
    <div class="flex justify-center">
      <Skeleton height="1.5rem" class="!w-1/2 bg-primary-300 dark:bg-primary-500" />
    </div>

    <!-- Title and Price form skeletons -->
    <div class="mb-4 flex flex-col gap-4">
      <!-- Title row -->
      <div class="grid grid-cols-12 items-center gap-2">
        <div class="col-span-2 min-w-4">
          <Skeleton height="1rem" class="w-16 bg-primary-300 dark:bg-primary-500" />
        </div>
        <div class="col-span-9 flex w-full justify-center">
          <Skeleton height="2.5rem" class="w-full bg-primary-300 dark:bg-primary-500" />
        </div>
      </div>

      <!-- Price row -->
      <div class="grid grid-cols-12 items-center gap-2">
        <div class="col-span-2 min-w-4">
          <Skeleton height="1rem" class="w-12 bg-primary-300 dark:bg-primary-500" />
        </div>
        <div class="col-span-9 flex w-full justify-center">
          <Skeleton height="2.5rem" class="w-full bg-primary-300 dark:bg-primary-500" />
        </div>
      </div>
    </div>

    <!-- Menu courses skeletons (3 courses) -->
    <div v-for="i in 3" :key="i" class="flex flex-col gap-3">
      <!-- Course header -->
      <!-- <div class="flex items-center justify-between">
        <Skeleton height="1.25rem" class="w-24 bg-primary-300 dark:bg-primary-500" />
        <Skeleton class="!w-6 !h-6 !rounded-full bg-primary-300 dark:bg-primary-500" />
      </div> -->

      <!-- Course content -->
      <div class="flex flex-row items-center gap-3">
        <Skeleton height="1rem" class="!w-20 bg-primary-300 dark:bg-primary-500" />
        <Skeleton class="!h-12 !w-full !rounded-lg bg-primary-300 dark:bg-primary-500" />
      </div>
      <!-- <div class="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
        <div class="flex-1">
          <Skeleton height="1.25rem" class="w-3/4 mb-2 bg-primary-300 dark:bg-primary-500" />
        </div>
      </div> -->
    </div>
  </div>
</template>
